import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsItFor() {
  const isFor = ['Madres de bebés entre 4 y 24 meses.', 'Mujeres que no quieren usar métodos de llanto descontrolado.', 'Mamás que trabajan y necesitan recuperar su claridad mental.', 'Familias que practican colecho o habitación compartida y quieren más estructura.'];
  const notFor = ['Personas que buscan una "cura mágica" de una sola noche.', 'Quienes prefieren dejar al bebé llorar solo detrás de una puerta cerrada.', 'Padres que no están dispuestos a ser constantes durante al menos una semana.'];
  return <section className="py-24 bg-white" data-id="element-207">
      <div className="max-w-6xl mx-auto px-6" data-id="element-208">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-20" data-id="element-209">
          {/* Es para ti */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="bg-cream p-8 md:p-10 rounded-3xl" data-id="element-210">
            <h3 className="text-2xl md:text-3xl font-serif text-navy mb-8 flex items-center" data-id="element-211">
              <span className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center mr-4 shrink-0" data-id="element-212">
                <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-213" />
              </span>
              Este método ES para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-214">
              {isFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-215">
                  <div className="w-2 h-2 rounded-full bg-amber mt-2.5 mr-4 shrink-0" data-id="element-216"></div>
                  <p className="text-navy/80 text-lg" data-id="element-217">{item}</p>
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-rose/5 p-8 md:p-10 rounded-3xl" data-id="element-218">
            <h3 className="text-2xl md:text-3xl font-serif text-navy mb-8 flex items-center" data-id="element-219">
              <span className="w-10 h-10 rounded-full bg-rose/20 flex items-center justify-center mr-4 shrink-0" data-id="element-220">
                <XCircle className="w-6 h-6 text-rose" data-id="element-221" />
              </span>
              NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-222">
              {notFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-223">
                  <div className="w-2 h-2 rounded-full bg-rose mt-2.5 mr-4 shrink-0" data-id="element-224"></div>
                  <p className="text-navy/80 text-lg" data-id="element-225">{item}</p>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}